/* Vanta Syntax Highlighter & Copy Button */
(function() {
    if (typeof document === 'undefined') return;

    var Prism = {
        highlightElement: function(codeEl) {
            if (!codeEl || codeEl.dataset.vantaHighlighted) return;
            codeEl.dataset.vantaHighlighted = "true";

            var text = codeEl.textContent || "";
            if (!text.trim()) return;

            var safeText = text
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");

            var tokens = [];
            var regex = /(\/\*[\s\S]*?\*\/|\/\/.+$|#.+)|("(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|`(?:\\.|[^`\\])*`)|(\b(?:interface|async|await|function|const|let|var|return|if|else|for|while|try|catch|class|import|export|from|extends|implements|new|this|type|of|in|instanceof|typeof|void|default|struct|enum|def|print)\b)|(\b(?:string|number|boolean|any|never|void|unknown|bigint|symbol|object|Promise|Array|Record|Set|Map|console|log)\b)|(\b[A-Z][A-Za-z0-9_]*\b)|(\b(?:true|false|null|undefined|NaN|True|False|None)\b|\b\d+(?:\.\d+)?\b)/gm;

            var tokenized = safeText.replace(regex, function(match, comment, string, keyword, builtin, className, number) {
                var cls = comment ? "comment" : string ? "string" : keyword ? "keyword" : builtin ? "builtin" : className ? "class-name" : number ? "number" : "";
                var id = "___TOKEN_" + tokens.length + "___";
                tokens.push('<span class="token ' + cls + '">' + match + '</span>');
                return id;
            });

            for (var i = 0; i < tokens.length; i++) {
                tokenized = tokenized.replace("___TOKEN_" + i + "___", tokens[i]);
            }

            codeEl.innerHTML = tokenized;
        },
        highlightAll: function() {
            var codeBlocks = document.querySelectorAll('pre code, .kg-code-card pre code, pre');
            codeBlocks.forEach(function(codeEl) {
                var pre = codeEl.tagName.toLowerCase() === 'pre' ? codeEl : codeEl.parentElement;
                var targetCode = codeEl.tagName.toLowerCase() === 'pre' ? (codeEl.querySelector('code') || codeEl) : codeEl;

                if (!pre || !targetCode) return;

                Prism.highlightElement(targetCode);

                if (!pre.querySelector('.vanta-copy-btn')) {
                    pre.style.position = 'relative';

                    var copyBtn = document.createElement('button');
                    copyBtn.className = 'vanta-copy-btn';
                    copyBtn.type = 'button';
                    copyBtn.setAttribute('aria-label', 'Copy code to clipboard');
                    copyBtn.innerHTML = '<span>Copy</span>';

                    copyBtn.addEventListener('click', function() {
                        var codeText = targetCode.textContent || text || '';
                        navigator.clipboard.writeText(codeText).then(function() {
                            copyBtn.innerHTML = '<span>Copied!</span>';
                            copyBtn.classList.add('copied');
                            setTimeout(function() {
                                copyBtn.innerHTML = '<span>Copy</span>';
                                copyBtn.classList.remove('copied');
                            }, 2000);
                        }).catch(function() {
                            copyBtn.innerHTML = '<span>Failed</span>';
                        });
                    });

                    pre.appendChild(copyBtn);
                }
            });
        }
    };

    window.Prism = Prism;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', Prism.highlightAll);
    } else {
        Prism.highlightAll();
    }
})();
